import { SxProps } from '@mui/system'
import { ComponentProps } from 'react'
import { useMemo } from 'react'

import { PostType } from '@/clients/utoniq-core/schema'
import { PostBox } from '@/components/organisms'

type PostDetailBoxProps = Pick<
  ComponentProps<typeof PostBox>,
  | 'post'
  | 'onLike'
  | 'onBlockArtist'
  | 'onReportArtist'
  | 'onReply'
  | 'isConsole'
  | 'onDeletePost'
  | 'loadingDeletePost'
  | 'userId'
> & {
  onClickShare?: () => Promise<void>
  isMembershipPersonalInformationRequired?: boolean
  enableEmbedHtml?: boolean
}

export const PostDetailBox = ({
  post,
  isMembershipPersonalInformationRequired,
  onLike,
  onBlockArtist,
  onReportArtist,
  onReply,
  isConsole,
  onDeletePost,
  loadingDeletePost,
  userId,
  enableEmbedHtml = false,
  onClickShare,
}: PostDetailBoxProps) => {
  const mediaSxProps = useMemo<SxProps>(() => {
    switch (post?.resourceType) {
      case PostType.Sound:
        return { height: 'fit-content' }
      case PostType.Image:
        return { height: '100%' }
      default:
        return { height: 266 }
    }
  }, [post?.resourceType])

  return (
    <PostBox
      isConsole={isConsole}
      post={post}
      isMembershipPersonalInformationRequired={
        isMembershipPersonalInformationRequired
      }
      userId={userId}
      fullWidth
      fullContent
      loadingDeletePost={loadingDeletePost}
      mediaProps={{ sx: mediaSxProps }}
      sx={{
        borderRadius: 0,
        backgroundColor: 'transparent',
        backgroundImage: 'unset',
        boxShadow: 'none',
        iframe: {
          height: 266,
        },
      }}
      enableEmbedHtml={enableEmbedHtml}
      clickable={false}
      onLike={onLike}
      onReply={onReply}
      onBlockArtist={onBlockArtist}
      onDeletePost={onDeletePost}
      onReportArtist={onReportArtist}
      onClickShare={onClickShare}
    />
  )
}
